export default __webpack_public_path__ + "static/media/VSCode.2a03a657.png";